import { CalendarDirection } from "@app/enum/CalendarDirection.enum";
import { DateService } from "./date.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CalendarService {

    constructor(private readonly dateService: DateService) { }

    isDayEnabled(date: Date, direction: CalendarDirection, allowedDates: Date[], minDate: Date): boolean {

        var today = new Date();

        if (allowedDates?.length) {
            return allowedDates.some(allowedDate => this.dateService.isSameDate(date, allowedDate));
        }

        switch (direction) {
            case CalendarDirection.Any:
                return true;

            case CalendarDirection.TodayPast:
                return this.dateService.isSameDate(date, today) || this.dateService.date1IsAfterDate2(today, date);

            case CalendarDirection.Past:
                return this.dateService.date1IsAfterDate2(today, date);

            case CalendarDirection.TodayFuture:
                return this.dateService.isSameDate(date, today) || this.dateService.date1IsAfterDate2(date, today);

            case CalendarDirection.Future:
                return this.dateService.date1IsAfterDate2(date, today);

            case CalendarDirection.AfterMinDate:
                return this.dateService.date1IsAfterDate2(date, minDate) || this.dateService.isSameDate(date, minDate);         
        }
    }
}